import React from 'react'
import Home from 'src/app/Home/Home'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { homeRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const HomeAppRoute: AppRoute = {
  id: AppLocation.Home,
  routeProps: homeRouteProps,
  component: <Home />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default HomeAppRoute
